import React from 'react';
import ReactDOMServer from 'react-dom/server';
import DatePosted from 'components/DatePosted';
import { BasicOpportunity } from 'lib/models/opportunity';

export const opportunityCardParser = (
  dataArray: BasicOpportunity[],
  type: string
): string => {
  try {
    if (!Array.isArray(dataArray) || dataArray.length === 0) {
      return '';
    }

    const htmlStrings = dataArray.map((data, index) => {
      const { public_url, title, created_at, basic_creatable_for } = data;

      return ReactDOMServer.renderToString(
        <a
          key={index}
          href={public_url}
          target="_blank"
          style={{
            textDecoration: 'none',
            boxShadow: '0px 1px 3px 0px rgba(8, 12, 11, 0.05)',
          }}
          rel="noreferrer"
        >
          <table
            width="100%"
            style={{
              width: '100%',
              borderRadius: '8px',
              backgroundColor: 'white',
              boxShadow: '0px 1px 3px 0px rgba(8, 12, 11, 0.05)',
              padding: '7px 16px',
              border: '1px solid #fafafa',
              margin: '8px 0',
            }}
          >
            <tr>
              <td width="50" style={{ paddingRight: '12px' }}>
                <img
                  src={basic_creatable_for.icon_url}
                  width="40"
                  height="40"
                  style={{
                    display: 'block',
                    borderRadius: '50%',
                    border: '0.5px solid  rgba(244, 246, 248, 0.1)',
                    objectFit: 'cover',
                    marginTop: '4px',
                  }}
                />
              </td>
              <td style={{ verticalAlign: 'top' }}>
                <table width="100%">
                  <tr>
                    <td style={{ paddingBottom: '4px' }}>
                      <h3
                        style={{
                          fontFamily: 'Inter',
                          fontSize: '1rem',
                          lineHeight: '1.375rem',
                          fontWeight: 600,
                          margin: '0',
                          WebkitFontSmoothing: 'antialiased',
                        }}
                      >
                        {title}
                      </h3>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        color: '#080c0bbd',
                        marginTop: '2px',
                        display: 'flex',
                        flexWrap: 'wrap',
                      }}
                    >
                      <span
                        style={{
                          fontFamily: 'Inter',
                          fontSize: '.8125rem',
                          lineHeight: '1.125rem',
                          fontWeight: 500,
                          WebkitFontSmoothing: 'antialiased',
                          color: '#080c0bbd',
                        }}
                      >
                        {basic_creatable_for.name}
                      </span>
                      <span
                        style={{
                          fontFamily: 'Inter',
                          fontSize: '.8125rem',
                          lineHeight: '1.125rem',
                          fontWeight: 500,
                          WebkitFontSmoothing: 'antialiased',
                          color: '#080c0bbd',
                          margin: '0 4px',
                        }}
                      >
                        •
                      </span>
                      <DatePosted
                        style={{
                          fontFamily: 'Inter',
                          fontSize: '.8125rem',
                          lineHeight: '1.125rem',
                          fontWeight: 500,
                          WebkitFontSmoothing: 'antialiased',
                          color: '#080c0bbd',
                          margin: 0,
                        }}
                        created_at={created_at}
                      />
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </a>
      );
    });

    return `
    <div style="padding:40px 0">
      ${
        type
          ? `
        <p style="
          color: #009479;
          font-family: Inter;
          font-size: 16px;
          font-style: normal;
          font-weight: 800;
          line-height: 20px;
          letter-spacing: -0.33px;
        ">
        💼 ${type}
        </p>`
          : ''
      }
      <div class="opportunity-card-tool">
        ${htmlStrings.join('')}
      </div>
    </div>`;
  } catch (error) {
    return '';
  }
};
